import React from "react";
// import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Link } from "react-router-dom";

function HomePage() {
  return (
    <div className="HomePage">
      <header className="hero">
        <h1 className="hero-text">
          Hi, I am
          <span> Delzad Bamji.</span>
        </h1>
        <p className="h-sub-text">
          I'm a Software Developer with a Masters in Computer Science. I create
          solutions for software-related problem statements and develop applications - be it on the web, in a project, or related to data
          engineering. I spend most of my time writing scripts in Python for
          various projects that I work on, or sometimes just if I want a brain
          teaser. I also enjoy creating frontend and backend components for web
          applications. What do I do in my free time? Binge on tv shows and movies, upskilling, read a book,
          tweak recipes in the kitchen, or I'm outside biking and hiking.
        </p>
        <div className="icons">
          {/* <a href="/" className="icon-holder">
            <FontAwesomeIcon icon={faFacebook} className="icon fb" />
          </a> */}
          <a
            href="http://github.com/delzadbamji"
            className="icon-holder"
            target="_blank"
          >
            <FontAwesomeIcon icon={faGithub} className="icon gh" />
          </a>
          <a
            href="https://www.linkedin.com/in/delzad-bamji/"
            className="icon-holder"
            target="_blank"
          >
            <FontAwesomeIcon icon={faLinkedin} className="icon lin" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCy7eeqbpOk6J-Hj--o4KIgQ"
            className="icon-holder"
            target="_blank"
          >
            <FontAwesomeIcon icon={faYoutube} className="icon yt" />
          </a>
          <a
            href="https://www.instagram.com/delzadbamji/"
            className="icon-holder"
            target="_blank"
          >
            <FontAwesomeIcon icon={faInstagram} className="icon insta" />
          </a>
        </div>
      </header>
    </div>
  );
}

export default HomePage;
